import { useContext, useMemo, useState } from "react";
import FormContext from "../../providers/FormContext";
import {
  parseToNumber,
  TextEditorNumber
} from "../../../shared/components/Editors";
import CSS from "csstype";

const Input = (props: any) => {
  const [localValue, setLocalValue] = useState(
    props.filterKey ? props.item?.[props.filterKey] : ""
  );
  const { disabled, getData, setData } = useContext(FormContext);

  const displayName = (): CSS.Properties => {
    const displayTrue: CSS.Properties = { display: "block" };
    const hidden: CSS.Properties = { visibility: "hidden" };
    const displayFalse: CSS.Properties = { display: "none" };

    if (props.name !== undefined) return displayTrue;
    if (props.useLabelSpace !== undefined) {
      if (props.useLabelSpace) return hidden;
    }
    return displayFalse;
  };

  const getAdditionalValue = () => {
    const adds = getData("additionals");
    if (adds) {
      const item = adds.filter((add: any) => add.Id === props.formKey);
      if (item.length > 0) return item[0].Value;
    }
    return undefined;
  };

  const currentValue = useMemo(() => {
    if (props.isAdditional) return getAdditionalValue();
    const ctxVal = getData(props.formKey);
    return ctxVal !== undefined && ctxVal !== null ? ctxVal : localValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isAdditional, props.formKey, getData, localValue]);

  const handleInput = (e: any) => {
    // para type="text" legacy
    if (props.type === "text") {
      if (props.callback) {
        if (props.isAdditional) {
          props.callback(props.formKey, e.target.value);
          setLocalValue(e.target.value);
        } else {
          props.callback(e);
          setLocalValue(e.target.value);
        }
      } else {
        setLocalValue(e.target.value);
        setData(props.formKey, e.target.value);
      }
    }
  };

  // NUEVO: handler para número (recibe string limpio desde TextEditorNumber)
  const handleNumberChange = (cleaned: string) => {
    // actualiza estado local para render
    setLocalValue(cleaned);

    if (props.callback) {
      if (props.isAdditional) {
        // si tu callback para adicionales espera (key, value)
        props.callback(props.formKey, cleaned);
      } else {
        // si tu callback espera evento, simulamos un target.value
        props.callback({ target: { value: cleaned } });
      }
      return;
    }

    // si no hay callback, persistimos en el contexto en formato numérico
    const n = parseToNumber(cleaned);
    setData(props.formKey, n ?? null);
  };

  const renderNumberInput = () => {
    const editorDefault = props.filterKey
      ? props.item?.[props.filterKey]
      : props.defaultValue;

    const editor = (
      <TextEditorNumber
        id={props.id}
        placeholder={props.placeholder}
        value={currentValue}
        defaultValue={editorDefault}
        disabled={disabled}
        onChange={handleNumberChange}
        className={props.inputClassName ?? "form-control text-end"}
        groupClassName="input-group"
        withBox={props.withBox}
        boxLeft={props.boxLeft}
        boxText={props.boxText}
        style={props.style}
        autoSelectOnFocus={props.autoSelectOnFocus}
      />
    );

    // Cuando withBox=false, TextEditorNumber devuelve solo <input/>,
    // y si withBox=true devuelve el input-group completo.
    // Para mantener tu estructura de label/clases, envolvemos igual.
    return (
      <div className={props.className}>
        {props.name ? (
          <label style={displayName()}>{props.name ?? "Default"}</label>
        ) : null}
        {editor}
      </div>
    );
  };

  if (props.type === "number") {
    return renderNumberInput();
  }

  // legacy text input (sin caja)
  return (
    <div className={props.className}>
      <label style={displayName()}>{props.name ? props.name : "Default"}</label>
      <input
        type="text"
        value={currentValue}
        className="form-control"
        onChange={handleInput}
        placeholder={props.placeholder}
        pattern={props.pattern}
        disabled={disabled}
      />
    </div>
  );
};

export default Input;
